import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { getStudySectionId, isPingguoUnion } from '../../../../util';
import {
  getResourceLibGrades,
  getResourceLibSchoolPeriod,
  getResourceLibSubjects,
} from '../../../../redux/action/base.action';

// 获取基本筛选基本信息
// 获取全局搜索或者资源库的筛选数据
function useFilterInfo() {
  const studySectionCode = getStudySectionId();
  // const subject = useRef();
  const resourceTypes = [
    { id: 1, code: '1', name: '课堂实录' },
    { id: 2, code: '2', name: '课件' },
    { id: 3, code: '3', name: '素材' },
    { id: 4, code: '4', name: '教案' },
    { id: 5, code: '5', name: '普通作业' },
    { id: 6, code: '6', name: '普通试卷' },
  ];
  const { grades, schoolPeriodList, subjects } = useSelector((state: any) => ({
    grades: state.Base.gradesList,
    schoolPeriodList: state.Base.schoolPeriodList,
    subjects: state.Base.subjectsList,
  }));

  // 年级
  useEffect(() => {
    !isPingguoUnion() && getResourceLibGrades(studySectionCode);
  }, [studySectionCode]);

  // 学届
  useEffect(() => {
    !isPingguoUnion() && getResourceLibSchoolPeriod();
  }, []);

  // 学科
  useEffect(() => {
    // !isPingguoUnion() && (subject.current = getSubjectList());
    !isPingguoUnion() && getResourceLibSubjects(studySectionCode);
  }, [studySectionCode]);

  return [
    resourceTypes,
    grades,
    subjects,
    // subject.current,
    [...schoolPeriodList].sort((a: any, b: any) => a.id - b.id),
  ];
}

export default useFilterInfo;
